module.exports = __webpack_public_path__ + "static/media/Apercu-Bold.ac601200.woff";